import apiProductList from './apiProductList.json';
import cosmeticsPersonalCare from './cosmeticsPersonalCare.json';


const allSources = [
    apiProductList,
    cosmeticsPersonalCare,
    
];

// ✅ Clean + map only valid entries
const combinedData = allSources.flatMap((source) =>
    (source || [])
        .filter(item => item.productName || item.name) // Avoid empty entries
        .map((item) => ({
            productName: item.productName || item.name,
            casNumber: item.casNumber || "N/A",
            description: item.description || `Product description is currently not available.
We are working on updating the details and will add them shortly.
For any inquiries or to learn more about this product, please don’t hesitate to get in touch with us.
You can reach us by filling out the Contact Us form, sending us an email, or contacting us directly via WhatsApp or phone call.`
        }))
);

export default combinedData;
